
import { Component, Vue } from 'vue-property-decorator';
import SearchBar from '../components/SearchBar.vue';
import RegulatorAccountMenu from './components/RegulatorAccountMenu.vue';
import AppBar from '@/ui-components/AppBar/AppBar.vue';
import AppBarStart from '@/layouts/components/AppBarStart.vue';
import SideNav from '@/layouts/components/SideNav.vue';
import namespaces from '@/store/namespaces';
import { UserRouteNames } from '@/types/users';
import { Getter } from 'vuex-class';
import { sharedNavButtons } from "@/statics/nav-buttons";
import NavButtons from "@/ui-components/NavButtons/NavButtons.vue";
import { initializeLanguageAndDirection } from "@/utils/locale";


@Component({
  name: 'RegulatorLayout',
  components: {
    SideNav,
    AppBarStart,
    AppBar,
    SearchBar,
    RegulatorAccountMenu,
    NavButtons,
  },
})
export default class RegulatorLayout extends Vue {
  @Getter('isAuthenticated', { namespace: namespaces.AuthModule })
  public isAuthenticated!: boolean;

  @Getter('userRouteNames', { namespace: namespaces.AuthModule })
  public userRouteNames!: UserRouteNames;

  public get dashboardRoute() {
    return this.userRouteNames.DASHBOARD;
  }

  public regulatorNavButtons = sharedNavButtons;

  created() {
    initializeLanguageAndDirection(this.$route);
  }
}
